<div class="d-flex justify-content-start align-items-center">
	<div class="condition-block d-inline-block bg-light-blue rounded-panel p-3 h4 text-center my-3">
		IF
	</div>
	<div class="d-flex align-items-center ps-3">
		<span class="me-2">Match</span>
		<rl-dropdown-single [options]="operatorOptions" [(ngModel)]="selectedOperator"
			(ngModelChange)="onOperatorChange()">
		</rl-dropdown-single>
		<span class="ms-2">of the following conditions</span>
	</div>
</div>
<div class="rounded-panel bg-light p-3">
	<div class="condition-builder">
		@for (control of rows.controls; track control; let i = $index; let isLast = $last) {
			<div class="condition-row d-flex align-items-center mb-2">
				<rl-query-node-row [queryFormControl]="control" [charTypeId]="charTypeId()"
					[queryNodeStrategies]="strategies()">
				</rl-query-node-row>
				<button type="button" class="btn btn-icon btn-remove ms-auto" (click)="removeRow(i)">
					<i class="fal fa-times"></i>
				</button>
			</div>
			@if(!isLast) {
				<div class="p-1">
					@switch(selectedOperator.key) {
						@case ("$or") {
							<strong>OR</strong>
						}
						@case ("$and") {
							<strong>AND</strong>
						}
					}
				</div>
			}
		}

		<button type="button" class="btn btn-sm btn-link" (click)="addRow()">
			<i class="far fa-plus me-1"></i>Add Condition
		</button>
	</div>
</div>

<div class="condition-block d-inline-block bg-light-blue rounded-panel p-3 h4 text-center my-3">
	THEN
</div>